import { type LoaderFunctionArgs, redirect, replace } from 'react-router-dom';

import { clearFilterObjectSearchParams } from 'components/QFilterSelect/types';

export const transactionReviewPath = '/transaction-review';

export function loadTransactionReview({ request }: LoaderFunctionArgs): Response {
  const url = new URL(request.url);
  const params = url.searchParams;

  // Review always starts with all unreviewed transactions. Retain campaign and
  // dataset parameters, but discard register filters and detail/tab selections.
  clearFilterObjectSearchParams(params);
  for (const key of ['q', 'displayNode', 'tab', 'txnId']) {
    params.delete(key);
  }
  params.set('isReviewed', '0');
  const destination = `/transactions?${params.toString()}`;

  // In-app navigation commits only the redirect destination, so push it and keep
  // the previous page for Back. A cold visit or Back already has this URL in
  // browser history; replace it so Back leaves instead of redirecting here again.
  return url.pathname === window.location.pathname ? replace(destination) : redirect(destination);
}
